import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loading: {
		id: 'polaris-lib-concurrent-updates.common.placeholder.loading',
		defaultMessage: 'Loading the author of the latest update',
		description: 'Loading the author of the latest update ',
	},
});
